var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload"},[_c('input',{ref:"thumbnail",style:({'width':_vm.width +'px','height':_vm.height + 'px'}),attrs:{"type":"file","id":"input","multiple":_vm.multiple},on:{"change":_vm.doUpload}})])}
var staticRenderFns = []

export { render, staticRenderFns }